import { createContext, useReducer } from "react";


const inicio:number=0
export const Mostrar=createContext<any>(inicio);

const reducer=(state:any,action:any):number=>
{
    return action.input.eleccion;
}

export const Mostr=({children}:any)=>
{
    const [Mostrardo,dispatch]=useReducer(reducer,inicio);

    const Actualizar=(number:number)=>
    {
        dispatch({input:{eleccion:number}})
    }

    return (
        <Mostrar.Provider value={{Mostrardo,Actualizar}}>
            {children}
        </Mostrar.Provider>
    )
}